module.exports = __webpack_public_path__ + "img/pic_404.e7c112f0.svg";